import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export function capitalizeFirst(value?: string | null) {
    if (!value) return ""
    const trimmed = value.trim()
    if (!trimmed) return ""
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1)
}

export type LocationParts = {
    city?: string | null
    state?: string | null
    country?: string | null
    location?: string | null
}

export function formatLocation(parts: LocationParts) {
    const values = [parts.city, parts.state, parts.country]
        .map((value) => (value ?? "").trim())
        .filter(Boolean)

    if (values.length > 0) return values.join(", ")
    return (parts.location ?? "").trim()
}

/**
 * Converts a job slug to a human-readable title.
 * Removes the trailing random numeric segment that slugs often have (e.g. "-123456")
 * and converts kebab-case to Title Case.
 *
 * @example
 * slugToTitle("software-engineer-remote-456789") // "Software Engineer Remote"
 * slugToTitle("registered-nurse-123")            // "Registered Nurse"
 */
export function slugToTitle(slug: string): string {
    const cleaned = slug.replace(/-\d+$/, "")
    return cleaned
        .split("-")
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
}
